<!-- Display the date in a pretty/consistent way -->
<script lang="ts" setup>
    import { computed } from "vue"
    import PrettyTime from './PrettyTime.vue'
    import * as DateUtils from '../lib/DateUtils'


    const props = withDefaults(defineProps<{
        date?: Date | string,
        showTime: boolean
    }>(), {
        showTime: true
    });

    const dateObject = computed<Date|undefined>(() => {
            if (!props.date)
                return;

            let tempDate = props.date;
            if ("string" == typeof (tempDate))
                tempDate = new Date(tempDate);
            return tempDate;
        });

    const formattedDate = computed(() => {
            return DateUtils.prettyDate(dateObject.value);
        });

</script>

<template>
    <span v-if="formattedDate">
        {{formattedDate}}
        <span v-if="showTime"> 
            <PrettyTime :date="date" />
        </span>
    </span>
</template>